import { FC } from 'react'
import { Img } from 'components/basic/Img'
import styles from './BestPerformers.module.scss'
import { BestPerformerCard } from './BestPerformerCard'

export const BestPerformers: FC = () => {
	return (
		<div className={styles.root}>
			<div className={styles.title_container}>
				<div className={styles.subtitle}>Stories from champions</div>
				<div className={styles.title}>Designed for the best performers</div>
			</div>

			<div className={styles.performers_list}>
				<BestPerformerCard
					videoSrc="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/6a246f82f2a646efa0706b86a6a0383a.mp4"
					videoThumb="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes/best-performers-1.jpg"
					quote="Justin slept on the Pod while training for the 2021 and 2022 CrossFit Games, which he won twice in a row."
					quoteAuthor="Justin Medeiros, 2X Fittest Man on Earth"
				/>

				<div className={styles.performer_content_container}>
					<div className={styles.performer_content_title_container}>
						<div className={styles.performer_content_title}>The Pod has been such an integral part of Taylor’s training routine, that he now takes it to all Grand Slams.</div>
						<div className={styles.performer_content_subtitle}>Taylor Fritz, highest ranked American male tennis player</div>
					</div>
				</div>

				<div className={styles.media_container}>
					<Img
						src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/taylor-fritz-featured-athlete-new.jpg"
						alt="taylor fritz"
						objectFit="cover"
					/>
				</div>

				<div className={styles.media_container}>
					<Img
						src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes/best-performers-3.png"
						alt="jennifer brady"
						objectFit="cover"
					/>
				</div>

				<div className={styles.performer_content_container}>
					<div className={styles.performer_content_title_container}>
						<div className={styles.performer_content_title}>Jennifer takes her recovery game to the next level with the Pod while competing in the US Open.</div>
						<div className={styles.performer_content_subtitle}>Jennifer Brady, professional tennis player</div>
					</div>
				</div>
			</div>
		</div>
	)
}
